import { ManageEntityFormValue } from './manage-entity.interfaces';

export function createManageEntityFormValue(): ManageEntityFormValue {
  return {
    entity_name: '',
    entity_type: '',
    status: '',
  };
}